(function ($, undefined) {
    // The global bdjs object
    var bdjs = {};

    // Set as a browser global
    window.bdjs = bdjs;

	/**
	*  strReplace
	*
	*  Performs a string replace
	*
	*  @param	string search
	*  @param	string replace
	*  @param	string subject
	*  @return	string
	*/

    bdjs.strReplace = function (search, replace, subject) {
        return subject.split(search).join(replace);
    };

    bdjs.isUndefined = function(value){
        return typeof value == 'undefined';
    };

	/**
	*  parseArgs
	*
	*  Merges together defaults and args much like the WP wp_parse_args function

	*  @param	object args
	*  @param	object defaults
	*  @return	object
	*/

	bdjs.parseArgs = function( args, defaults ){
		if( typeof args !== 'object' ) args = {};
		if( typeof defaults !== 'object' ) defaults = {};
		return $.extend({}, defaults, args);
	}


    // Global block storage
    bdjs.blocks = [];

    /**
	*  registerBlock
	*
    *  register new bd block.
    
	*  @param	object block
	*  @return	void
	*/
    bdjs.registerBlock = function (block) {
        bdjs.blocks.push(block);
    };

	/**
	*  getBlocks
	*
	*  Get all blocks
	*  @return	object
	*/

    bdjs.getBlocks = function () {
        return bdjs.blocks;
    }

	/**
	*  getBlock
	*
	*  Get block by type
	*
	*  @param	string type
	*  @return	object
	*/

    bdjs.getBlock = function (type) {
        var block = null;

        bdjs.blocks.forEach(function (item, index) {
            if (item.type == type) {
                block = bdjs.blocks[index];
            }
        });

        return block;
    }

		/**
		* Make ajax request
		* @return {Promises}
		*/
    bdjs.makeRequest = function (URL, objData) {
			const request = axios.post;

			const formData = new FormData();

			for (const prop in objData) {
				formData.append(prop, objData[prop]);
			}
			
			return request( URL, formData, { "Content-Type": "multipart/form-data" });
    }

    bdjs.removeItemArray = function(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
            arr.splice(index, 1);
        }

        return arr;
    }

	bdjs.isArray = function (any) {
		// Only implement if no native implementation is available
		if (typeof Array.isArray === "undefined") {
			Array.isArray = function (obj) {
				return Object.prototype.toString.call(obj) === "[object Array]";
			};
		}
		return Array.isArray(any);
    }
    
    bdjs.keyLength = function(object) {
        return Object.keys(object).length;
	}

	bdjs.escapeHtml = function(string) {
		var entityMap = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;',
			'/': '&#x2F;',
			'`': '&#x60;',
			'=': '&#x3D;'
		  };

		return String(string).replace(/[&<>"'`=\/]/g, function (s) {
		  return entityMap[s];
		});
	}


	bdjs.showLoading = function (callback) {
		if (typeof callback !== 'function') return

		if(CFG.game_options.transition_between_building_block === 'none') {
			callback();
		} else {
			$('#page').addClass('is-loading');
			setTimeout(function () {	
				callback();
			}, CFG.game_options.transition_between_building_block === 'milky-layer' ? 3000 : 1000);
		}
	}

	bdjs.hideLoading = function (callback) {
			setTimeout(() => {
				$('#page').removeClass('is-loading');
				
				if (typeof callback !== 'function') return

				if(CFG.game_options.transition_between_building_block === 'none') {
					callback();
				} else {
					setTimeout(function () {
						callback();
					}, 1000);
				}

			}, 200);
	}

	/**
	*  addAction
	*
	*  Wrapper for bdjs.hooks.addAction
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.addAction = function( action, callback, priority, context ){
		bdjs.hooks.addAction.apply(this, arguments);
		return this;
	};

	/**
	*  removeAction
	*
	*  Wrapper for bdjs.hooks.removeAction
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.removeAction = function( action, callback ){
		//action = prefixAction(action);
		bdjs.hooks.removeAction.apply(this, arguments);
		return this;
	};

	/**
	*  doAction
	*
	*  Wrapper for bdjs.hooks.doAction
	*
	*  @param	n/a
	*  @return	this
	*/

	var actionHistory = {};
	//var currentAction = false;
	bdjs.doAction = function( action ){
		//action = prefixAction(action);
		//currentAction = action;
		actionHistory[ action ] = 1;
		bdjs.hooks.doAction.apply(this, arguments);
		actionHistory[ action ] = 0;
		return this;
	};

	/**
	*  doingAction
	*
	*  Return true if doing action
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.doingAction = function( action ){
		return (actionHistory[ action ] === 1);
	};


	/**
	*  didAction
	*
	*  Wrapper for bdjs.hooks.doAction
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.didAction = function( action ){
		//action = prefixAction(action);
		return (actionHistory[ action ] !== undefined);
	};

	/**
	*  currentAction
	*
	*  Wrapper for bdjs.hooks.doAction
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.currentAction = function(){
		for( var k in actionHistory ) {
			if( actionHistory[k] ) {
				return k;
			}
		}
		return false;
	};

	/**
	*  addFilter
	*
	*  Wrapper for bdjs.hooks.addFilter
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.addFilter = function( action ){
		//action = prefixAction(action);
		console.log('action', action, arguments)
		bdjs.hooks.addFilter.apply(this, arguments);
		return this;
	};


	/**
	*  removeFilter
	*
	*  Wrapper for bdjs.hooks.removeFilter
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.removeFilter = function( action ){
		bdjs.hooks.removeFilter.apply(this, arguments);
		return this;
	};


	/**
	*  applyFilters
	*
	*  Wrapper for bdjs.hooks.applyFilters
	*
	*  @param	n/a
	*  @return	this
	*/

	bdjs.applyFilters = function( action ){
		//action = prefixAction(action);
		return bdjs.hooks.applyFilters.apply(this, arguments);
	};

	/**
	*  bdjs.prepareForAjax
	*
	*  @param	type $var Description. Default.
	*  @return	type Description.
	*/

	/**
	 * @description ### Returns Go / Lua like responses(data, err)
	 * when used with await
	 *
	 * - Example response [ data, undefined ]
	 * - Example response [ undefined, Error ]
	 *
	 *
	 * When used with Promise.all([req1, req2, req3])
	 * - Example response [ [data1, data2, data3], undefined ]
	 * - Example response [ undefined, Error ]
	 *
	 *
	 * When used with Promise.race([req1, req2, req3])
	 * - Example response [ data, undefined ]
	 * - Example response [ undefined, Error ]
	 *
	 * @param {Promise} promise
	 * @returns {[undefined |  any, Error |  undefined]} [ data, err ]
	 */
	bdjs.goAsync = (promise) => {
		return promise
		.then((data) => [data, undefined])
		.catch((err) =>
			Promise.resolve([
			undefined,
	
			// if error happen but we got falsy value for the `error` variable, then
			// return true, so we can catch the error in the next code
			err || true,
			]),
		);
	};
})(jQuery);
